(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
    $(document).ready(function () {  
        $('.announcement-slider').slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        arrows: false,
        dots: false,
        infinite: true,
        pauseOnHover: false,
        adaptiveHeight: false
        });  
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-appointment"]) return;
  try {
    
    document.querySelector('.appointment-type-dropdown').addEventListener('change',function(){
        if (this.value) window.location.href = this.value;
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-guide"]) return;
  try {
    
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() { 
    var slider = document.querySelector('.category-slider');

    if (slider) {
      $('.category-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
         appendArrows: $('.category-column-section .slider-arrows'), 
        // prevArrow: '<button class="slick-prev" aria-label="Previous"><</button>',
        // nextArrow: '<button class="slick-next" aria-label="Next">></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.58,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["celebrity-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() { 
    var slider = document.querySelector('.celebrity-slider');

    if (slider) {
      $('.celebrity-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true, 
        autoplaySpeed: 3000,
         appendArrows: $('.celebrity-column-section .slider-arrows'), 
        // prevArrow: '<button class="slick-prev" aria-label="Previous"><</button>',
        // nextArrow: '<button class="slick-next" aria-label="Next">></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.77,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-collection-slider"] && !Shopify.designMode) return;
  try {
    
  $('.hp-collection-slider-wrapper').each(function(){
   var $wrapper = $(this);
    var $slider  = $wrapper.find('.hp-collection-slick-slider');
    var $arrows  = $wrapper.find('.slider-arrows');

    // Prevent double initialization
    if ($slider.length && !$slider.hasClass('slick-initialized')) {

      $slider.slick({
   // slidesToShow: 4.7,
    slidesToShow: 4.7,
    slidesToScroll: 1,
    arrows: true,
    dots: false, 
    speed: 400,
    appendArrows: $('.hp-collection-slider-wrapper .slider-arrows'), 
    // prevArrow: '<button class="slick-prev" aria-label="Previous"><</button>',
    // nextArrow: '<button class="slick-next" aria-label="Next">></button>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5
        }
      },
      // {
      //   breakpoint: 992,
      //   settings: {
      //     slidesToShow: 3.5
      //   }
      // },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1.7, 
          initialSlide: 1
        }
      }
    ]
    
  });
};  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-slider-banner"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function(){
    $('.slick-slider-banner').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"]) return;
  try {
    
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


  } catch(e) { console.error(e); }
})();
})();
